import { Link } from "react-router-dom";

export default function SiteHeader() {
  const scrollToForm = () => document.getElementById("final-cta")?.scrollIntoView({ behavior: "smooth" });
  return (
    <header className="fixed top-0 inset-x-0 z-40 bg-[#F9F7F3]/75 backdrop-blur-xl border-b border-[#E5E1D8]/70" data-testid="site-header">
      <div className="max-w-6xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
        <Link to="/" className="font-display text-xl sm:text-2xl tracking-tight" data-testid="header-logo-link">
          Chiara Piccioni
        </Link>
        <button
          onClick={scrollToForm}
          data-testid="header-cta-button"
          className="btn-ghost text-sm font-semibold px-5 h-10 rounded-full border border-[#1E231F] hover:bg-[#1E231F] hover:text-white"
        >
          Guida gratis
        </button>
      </div>
    </header>
  );
}
